/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Resolve_Fail_Note_PlaceholderInputs */

const vi_trip_resolve_fail_note_placeholder = /** @type {(inputs: Trip_Resolve_Fail_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do giao thất bại (bắt buộc, tối thiểu 3 ký tự)`)
};

/**

* @param {Trip_Resolve_Fail_Note_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_resolve_fail_note_placeholder = /** @type {((inputs?: Trip_Resolve_Fail_Note_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Resolve_Fail_Note_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_resolve_fail_note_placeholder(inputs)
});